var React = require('react');

function ArrowE (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n            .cls-1, .cls-2 {\n                fill: none;\n                stroke-miterlimit: 8;\n            }\n            \n            .cls-1 {\n                stroke-linecap: square;\n            }\n            \n            .cls-2 {\n                stroke-linecap: round;\n            }\n        ")),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":1},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},[React.createElement("path",{"className":"cls-1","d":"M20.37,10.77l5-5-5-5","key":0}),React.createElement("path",{"className":"cls-1","d":"M.5,5.74H24.57","key":1}),React.createElement("path",{"className":"cls-2","d":"M25.4,5.74h-.83","key":2})]))]);
}

ArrowE.defaultProps = {"viewBox":"0 0 26.11 11.48","width":"28","height":"28","stroke":"#231f20"};

module.exports = ArrowE;

ArrowE.default = ArrowE;
